<eb-main-s1
  #s1
  [form]="originalBody!"
  [showAmendment]="status?.isViewingAmendment ?? false"
  [isLogView]="true"
></eb-main-s1>
